module.exports = __webpack_public_path__ + "static/media/Caitlin Holland Headshot.5e64615a.jpeg";